import { localize } from "client_legacy/ndaw/culture";
import { never } from "client_legacy/ndaw/errors";
import { Address, NedapOnsGender } from "client/Api/Workspace/LiveInformation/NedapOns/nedapOnsLiveInformation";

export function prefixNameWithGender(name: string, gender: NedapOnsGender): string {
	let nameWithGenderPrefix: string = "";
	switch (gender) {
		case NedapOnsGender.Male:
			nameWithGenderPrefix += localize("_MaleTitle") + " ";
			break;
		case NedapOnsGender.Female:
			nameWithGenderPrefix += localize("_FemaleTitle") + " ";
			break;
		case NedapOnsGender.Unknown:
			break;
		default:
			throw never(gender);
	}

	nameWithGenderPrefix += name;

	return nameWithGenderPrefix;
}

export function formatAddress(
	address: Address | null,
	isForWideView: boolean
): string {
	if (!address) {
		return "";
	}

	const {
		street,
		number,
		numberPostfix,
		zipCode,
		city
	} = address;

	const fullNumber: string = [number, numberPostfix]
		.filter(x => x)
		.join("-");

	const fullStreet = [street, fullNumber]
		.filter(x => x)
		.join(" ");

	const segments: string[] = isForWideView
		? [fullStreet, zipCode, city]
		: [fullStreet, city];

	return segments
		.filter(x => x)
		.join(", ");
}
